export const MAYOR_GREETING_MAX_LENGTH = 2000;
